export default __webpack_public_path__ + "static/media/logo-nice-header.6d80bfec.svg";